@let previewMode = isPreviewMode();
@let previewAllowed = canPreview();
@let currentVisibility = visibilityValue();
@let editorTitleKey = titleKey();
@let editorTitleParams = titleParams();

<div class="edit-modal__title-cont">
  <h2 mat-dialog-title class="edit-modal__title">
    {{ editorTitleKey | translate: editorTitleParams }}
  </h2>
  <button class="edit-modal___close" type="button" (click)="onCancel()" aria-label="Close">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <use [attr.href]="icons[IconName.CLOSE]" />
    </svg>
  </button>
</div>

<mat-dialog-content class="edit-modal__content">
  <div class="edit-modal__top-row">
    @if (!previewMode) {
      <div class="visibility-cont">
        <mat-slide-toggle
          [hideIcon]="true"
          [checked]="currentVisibility"
          (change)="onVisibilityToggle($event)"
        >
          {{ 'shop-settings.content.global-editor.visibility' | translate }}
        </mat-slide-toggle>
      </div>
    }

    <button
      type="button"
      class="edit-modal__preview-btn"
      (click)="togglePreview()"
      [disabled]="!previewAllowed"
    >
      {{
        (previewMode
          ? 'shop-settings.content.global-editor.edit'
          : 'shop-settings.content.global-editor.preview'
        ) | translate
      }}
    </button>
  </div>
  @switch (data.type) {
    @case ('content') {
      <app-edit-modal [data]="contentPayload" [isPreviewMode]="previewMode" />
    }

    @case ('teaser') {
      <app-teaser-editor-body [data]="teaserPayload" [isPreviewMode]="previewMode" />
    }

    @case ('offers') {
      <app-offers-editor-body [data]="offersPayload" [isPreviewMode]="previewMode" />
    }

    @case ('categories') {
      <app-categories-editor-body
        [allCategories]="allCategoriesData()"
        [data]="categoriesPayload"
        [isPreviewMode]="previewMode"
        [searchedCategories]="searchedCategories()"
        (searchChange)="categoriesSearchChanges($event)"
      />
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="edit-modal__actions">
  @if (!previewMode) {
    <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="isSaving()">
      {{ 'shop-settings.content.global-editor.cancel' | translate }}
    </button>

    <button type="button" class="btn-save" (click)="save()" [disabled]="isSaving()">
      {{
        (isSaving()
          ? 'shop-settings.content.global-editor.saving'
          : 'shop-settings.content.global-editor.save'
        ) | translate
      }}
    </button>
  } @else {
    <button type="button" class="btn-cancel-preview" (click)="onCancel()" [disabled]="isSaving()">
      {{ 'shop-settings.content.global-editor.cancel' | translate }}
    </button>
  }
</mat-dialog-actions>
